import * as React from 'react';
import { useSelector } from 'react-redux';
import { identity } from 'ramda';

import { Section } from '../../../components/Section';
import { MarketPriceContainer } from '../../MarketPriceContainer';
import { ValuationFiltersContainer } from '../../ValuationFiltersContainer';

import { HeroResultSectionContainer } from '../../HeroResultSectionContainer';
import { TabsContainer } from '../../TabsContainer';
import { AboutHomeContainer } from '../../AboutHomeContainer';
import { useScrollingRef } from '../../Scrolling';
import { EScrollingBlocks } from '../../../constants/scrollingBlocks';
import { OffersHistoryContainer } from '../../OfferHistory/Mobile';
import { ValuationContentContainer } from '../../ValuationContentContainer';
import { selectDealType, selectIsFromOfferCard } from '../../../selectors/page';
import { EstimationDealTypeBannerContainer } from '../../EstimationDealTypeBannerContainer';
import { RateApartmentContainer } from '../../RateApartmentContainer';
import { ObjectInfoContainer } from '../../ObjectInfoContainer';
import { RateOurEstimationContainer } from '../../RateOurEstimationContainer';
import { selectEstimationByDealType } from '../../../selectors/estimation';
import { ErrorScreen } from '../../../components/ErrorScreen';
import { MarketTrendsContainer } from '../../MarketTrendsContainer';
import { OtherServicesContainer } from '../../OtherServices';

import { MobileInfrastructureContainerLoad } from '../../InfrastructureMapContainer';
import { OnbordingContainer } from '../../OnbordingContainer';
import { ManagementCompanyContainer } from '../../ManagementCompanyContainer';
import { MyHomeMigrationBannerContainer } from '../../MyHomeMigrationBannerContainer';

export function MobilePageContainer() {
  const marketPriceRef = useScrollingRef(EScrollingBlocks.MarketPrice);
  const offersHistoryRef = useScrollingRef(EScrollingBlocks.OffersHistory);
  const valuationFiltersRef = useScrollingRef(EScrollingBlocks.ValuationFilters);
  const marketTrendsRef = useScrollingRef(EScrollingBlocks.MarketTrends);
  const dealTypeTabsRef = useScrollingRef(EScrollingBlocks.DealTypeTabs);
  const infrastructureRef = useScrollingRef(EScrollingBlocks.Infrastructure);
  const aboutHomeRef = useScrollingRef(EScrollingBlocks.AboutHome);
  const managementCompanyRef = useScrollingRef(EScrollingBlocks.ManagementCompany);

  const isFromOfferCard = useSelector(selectIsFromOfferCard);

  const dealType = useSelector(selectDealType);
  const estimation = useSelector(selectEstimationByDealType(dealType));
  if (estimation.isError) {
    return <ErrorScreen />;
  }

  return (
    <>
      <HeroResultSectionContainer />
      <ValuationFiltersContainer refWrapper={valuationFiltersRef} />

      <ValuationContentContainer>
        <Section marginTop={28} marginBottom={32}>
          <TabsContainer refWrapper={dealTypeTabsRef} />
          <EstimationDealTypeBannerContainer />
        </Section>
        <Section>
          <ObjectInfoContainer refWrapper={identity} />
        </Section>
        <Section>
          <MyHomeMigrationBannerContainer />
        </Section>
        <Section>
          <OnbordingContainer />
        </Section>
        <Section marginBottom={48}>
          <MarketPriceContainer refWrapper={marketPriceRef} />
          <RateOurEstimationContainer />
        </Section>

        <Section marginBottom={48}>{isFromOfferCard ? <RateApartmentContainer /> : <OtherServicesContainer />}</Section>
        <Section marginBottom={48}>
          <MarketTrendsContainer refWrapper={marketTrendsRef} />
        </Section>
        <Section marginBottom={48}>
          <OffersHistoryContainer refWrapper={offersHistoryRef} />
        </Section>
        <Section marginBottom={48}>
          <ManagementCompanyContainer refWrapper={managementCompanyRef} />
        </Section>
        <Section>
          <AboutHomeContainer refWrapper={aboutHomeRef} />
        </Section>
        <Section>
          <MobileInfrastructureContainerLoad refWrapper={infrastructureRef} />
        </Section>
      </ValuationContentContainer>
    </>
  );
}
